import React, { Component } from 'react'
import { Affix } from "antd"
import { observer, inject } from "mobx-react"

@inject('reportStore') @observer
export default class DataHeader extends Component {

  render() {
    const { tableData } = this.props.reportStore
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={0}
      >
        <div className="search-bar">
          <div className="left">
            <div>数据类型：{tableData.appName}</div>
            <div>家系名称：{tableData.name}</div>
            <div>创建时间：{tableData.createTime}</div>
          </div>
        </div>
      </Affix>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage_detail/containers/DataHeader.js